import { ActionType, createAsyncAction } from 'typesafe-actions';
import { OcrMap } from '@cmr/ocr-common';
import { Operation } from 'fast-json-patch';

const actions = {
  fetch: createAsyncAction('fetch/request', 'fetch/success', 'fetch/failure')<
    undefined,
    OcrMap[],
    { error: Error; statusCode?: number }
  >(),
  create: createAsyncAction(
    'create/request',
    'create/success',
    'create/failure',
  )<undefined, [undefined, OcrMap], { error: Error; statusCode?: number }>(),
  patch: createAsyncAction('patch/request', 'patch/success', 'patch/failure')<
    Operation[],
    OcrMap,
    { error: Error; statusCode?: number }
  >(),
};

export default actions;

export type OcrMapsAction = ActionType<typeof actions>;
